import React from "react";
import Icon from '@ant-design/icons';
import { AddSvg, AddSvg1, AddSop, EditSvg, TipsSvg, BackSvg, FileOpen, FileClose, TipsConfirm, MinimizeImg } from './svgs';

const getProps = (props, ReactComponent) => {
  const component = ReactComponent({ style: { width: "1em", height: "1em" }, ...props })
  return () => (component)
}

export const AddIcon = props => (<Icon component={getProps(props, AddSvg)} />);
export const TipsConfirmIcon = props => (<Icon component={getProps(props, TipsConfirm)} />);
export const AddSopIcon = props => (<Icon component={AddSop} {...props} />);
export const AddIcon1 = props => (<Icon component={AddSvg1} {...props} />);
export const EditIcon = props => (<Icon component={EditSvg} {...props} />);
export const TipsIcon = props => (<Icon component={TipsSvg} {...props} />);
export const BackIcon = props => (<Icon component={BackSvg} {...props} />);
export const FileOpenIcon = props => (<Icon component={FileOpen} {...props} />);
export const FileCloseIcon = props => (<Icon component={FileClose} {...props} />);
export const MinimizeIcon = props => (<Icon component={MinimizeImg} {...props} />);